import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { select_ui_settings, set_ui_settings } from 'console/redux/settings-actions';
import { memo, useCallback, useState } from 'react';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import * as S from './styles';
const marks = [
    { value: 0.7, label: 'Мелко' },
    { value: 0.8, label: '' },
    { value: 0.9, label: '' },
    { value: 1, label: 'По умолчанию' },
    { value: 1.1, label: '' },
    { value: 1.2, label: '' },
    { value: 1.3, label: '' },
    { value: 1.4, label: '' },
    { value: 1.5, label: 'Крупно' },
];
const ResizeCardsSlider = memo(function ResizeCardsSlider() {
    const setUISettings = useAction(set_ui_settings);
    const { tab_cards_size_multiplier = 1 } = useAppSelector(select_ui_settings);
    const [cards_size_multiplier, setCardsMultiplier] = useState(tab_cards_size_multiplier);
    const onSizeSliderCommitted = useCallback((_, value) => {
        if (!Array.isArray(value)) {
            setUISettings({ tab_cards_size_multiplier: value });
        }
    }, [setUISettings]);
    const onSizeSliderChange = useCallback((_, value) => {
        if (!Array.isArray(value)) {
            setCardsMultiplier(value);
        }
    }, [setCardsMultiplier]);
    return (_jsxs(Box, { width: "85%", display: "flex", flexDirection: "column", justifySelf: "center", children: [_jsx(Typography, { width: "100%", color: "primary.dark", textAlign: "center", variant: "caption", children: "\u0420\u0430\u0437\u043C\u0435\u0440 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432" }), _jsx(S.SizeSlider, { min: 0.7, max: 1.5, step: 0.1, marks: marks, value: cards_size_multiplier, onChangeCommitted: onSizeSliderCommitted, onChange: onSizeSliderChange })] }));
});
export { ResizeCardsSlider };
